import React, { useState } from 'react';
import { List, Typography } from "@mui/material";
import WaiverTemplates from '../../components/history/modals/WaiverTemplates';
import FileMaintenance from '../../components/common/modals/FileMaintenance';
import Services from '../../components/services/modals/Services';

const MaintenancePage = () => {
    // const [type, setType] = useState([]);

    return (
        <>
            <Typography variant="h4">Maintenance</Typography>
            <List>
              <Services />
              <WaiverTemplates />
              <FileMaintenance />
            </List>
        </>
    );
};

export default MaintenancePage;
